import { IKeyword } from '@/api/interfaces/IKeyword'
import { createT } from '@/locales/index'
import dayjs from 'dayjs'

export const formatDate = (date: any) => {
  return dayjs(date).format('YYYY.MM.DD')
}

export const formatDateWithTime = (date: any) => {
  return dayjs(date).format('YYYY.MM.DD HH:mm')
}

export const formatSeconds = (seconds?: number) => {
  if (!seconds || seconds <= 0) {
    return '0:00'
  }

  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds / 60) % 60)
  const s = Math.floor(seconds % 60)

  if (h > 0) {
    return `${h.toString().padStart(2, '0')}:${m
      .toString()
      .padStart(2, '0')}:${s.toString().padStart(2, '0')}`
  }

  return `${m.toString()}:${s.toString().padStart(2, '0')}`
}

export const fromNow = (
  date: string | number | Date | undefined,
  translations: IKeyword,
  withTime?: boolean,
) => {
  if (!date) {
    return ''
  }

  const now = dayjs()
  const dj = dayjs(date)

  const t = createT(translations)

  if (now.diff(dj, 'minute') < 60) {
    return t('ago-minute', { val: now.diff(dj, 'minute') })
  }

  if (now.diff(dj, 'hour') < 24) {
    return t('ago-hour', { val: now.diff(dj, 'hour') })
  }

  if (now.diff(dj, 'day') < 8) {
    return t('ago-date', { val: now.diff(dj, 'day') })
  }

  // TODO: 기획 보류
  // if (now.diff(dj, 'month') < 12) {
  //   return t('ago-month', { val: now.diff(dj, 'month') })
  // }

  if (withTime) {
    return formatDateWithTime(date)
  }

  return formatDate(date)
}
